import React, { useState, useEffect } from 'react';
import { validateAccountNumber, validateRoutingNumber } from './ACHValidation';
import SelectField from '@Components/Shared/Controls/SelectField';
import TextField from '@Components/Shared/Controls/TextField';
import Button from '@mui/material/Button';
import translator from '@Components/Utilities/Translator';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import { achFields } from '@Components/Utilities/SandhillsConstants';

const GlobalPaymentsACHForm = (props) => {
    const [loading, setLoading] = useState(false);
    const [accountType, setAccountType] = useState({ value: 'checking', valid: true });
    const [accountNumber, setAccountNumber] = useState({ value: '', valid: null });
    const [routingNumber, setRoutingNumber] = useState({ value: '', valid: null });

    useEffect(() => {
        props.ready?.();
    }, []);

    const handleFieldChanged = (setter, valid) => (e) => {
        setter({ value: e.target?.value?.trim() || "" , valid: valid});
    };

    const handleFieldBlur = (validater, setter, value) => (e) => {
        setter({ value: value, valid: value ? validater(value) : false });
    };

    const validateForm = () => {
        return accountNumber.valid && routingNumber.valid;
    }

    const submitForm = (e) => {
        e.preventDefault();

        if (validateForm() && !loading) {
            setLoading(true);
            let achFields = {
                accountType: accountType.value,
                accountNumber: accountNumber.value,
                routingNumber: routingNumber.value
            }
            
            props.success(achFields, () => setLoading(false));
        }
    };

    return (
        <div className='global-payments-pay-fields'>
            <div className='global-payments-ach-form'>
                {loading && <LoadingRing sxBox={{ 'justify-content': 'center' }} />}
                <SelectField
                    name={achFields.ACCOUNT_TYPE.Id}
                    class='ach-field'
                    value={accountType.value}
                    options={achFields.ACCOUNT_TYPE.Options}
                    label={achFields.ACCOUNT_TYPE.Label}
                    labelClass='ach-label'
                    onFieldChanged={handleFieldChanged(setAccountType)}
                    required
                />
                <TextField
                    name={achFields.ACCOUNT_NUMBER.Id}
                    class='ach-field'
                    value={accountNumber.value}
                    type='text'
                    label={achFields.ACCOUNT_NUMBER.Label}
                    labelClass='ach-label'
                    inputClass={accountNumber.valid === false ? 'invalid' : null}
                    validationErrors={accountNumber.valid === false ? `Invalid ${achFields.ACCOUNT_NUMBER.Label}` : null}
                    onFieldChanged={handleFieldChanged(setAccountNumber, accountNumber.valid)}
                    onFieldBlur={handleFieldBlur(validateAccountNumber, setAccountNumber, accountNumber.value)}
                    required
                />
                <TextField
                    name={achFields.ROUTING_NUMBER.Id}
                    value={routingNumber.value}
                    type='text'
                    class='ach-field'
                    label={achFields.ROUTING_NUMBER.Label}
                    labelClass='ach-label'
                    inputClass={routingNumber.valid === false ? 'invalid' : null}
                    validationErrors={routingNumber.valid === false ? `Invalid ${achFields.ROUTING_NUMBER.Label}` : null}
                    onFieldChanged={handleFieldChanged(setRoutingNumber, routingNumber.valid)}
                    onFieldBlur={handleFieldBlur(validateRoutingNumber, setRoutingNumber, routingNumber.value)}
                    required
                />
                <div id='check-error' className="error" style={{ textAlign: 'center', marginBottom: '15px' }}>
                    {props.error && <>{props.error}</>}
                </div>
                <Button variant="contained" disabled={loading} onClick={submitForm}>{translator.translate('sandhills.saveandsubmit')}</Button>
            </div>
            {(props.showLogo && props.LogoUrl) &&
                <div className={'payment-auth-logo'}>
                    <img src={props.LogoUrl} alt="" />
                </div>
            }
        </div>
    );
}

export default GlobalPaymentsACHForm;